import Vuex from 'vuex'
import Vue from 'vue'
import auth from '@/store/auth'
import entities from '@/store/entities'
import user from '@/store/user'
import staticData from '@/store/static'
import ui from '@/store/ui'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState({ paths: ['auth.authenticationData', 'user.currentLanguage', 'user.currentTheme'] })],
  modules: {
    auth,
    entities,
    user,
    ui,
    staticData
  }
})
